"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var default_1 = require("./default");
Object.defineProperty(exports, "Default", { enumerable: true, get: function () { return default_1.default; } });
//# sourceMappingURL=index.js.map